<template>
  <Modal class="my-modal" v-model="visible" width="800" title="账户设置" :footer-hide="true" :mask-closable="false">
    <Form ref="form" :model="formData" :label-width="80" class="page-form detail less">
      <!-- 账号信息 -->
      <div class="form-title">账号信息</div>
      <FormItem label="登录账号">
        <span>{{ formData.account }}</span>
      </FormItem>
      <FormItem label="所属机构" v-if="!isOperationAccount">
        <span>{{ formData.organizationName }}</span>
      </FormItem>
      <FormItem label="状态">
        <span>{{ formData.status === 0 ? '无效' : '有效' }}</span>
      </FormItem>
      <FormItem label="角色">
        <span>{{ formData.roles ? formData.roles.join(' ') : '' }}</span>
      </FormItem>
      
      <!-- 基本信息 -->
      <div class="form-title">基本信息</div>
      <FormItem label="用户姓名">
        <span>{{ formData.userName }}</span>
      </FormItem>
      <FormItem label="手机号">
        <span>{{ formData.mobile }}</span>
      </FormItem>
      <FormItem label="证件类型">
        <span>{{ getCardTypeName(formData.idType) }}</span>
      </FormItem>
      <FormItem label="证件号">
        <span>{{ formData.idNo }}</span>
      </FormItem>
      
      <!-- 安全信息 -->
      <div class="form-title">安全信息</div>
      <FormItem label="密码">
        <Button type="primary" @click="openChangePassword">修改密码</Button>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isOperationAccount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      formData: {},
      cardTypeOptions: []
    };
  },
  created() {
    this.initCardTypeOptions();
  },
  methods: {
    // 打开弹窗并初始化数据
    open(data) {
      this.formData = data || {};
      this.visible = true;
    },
    
    // 关闭弹窗
    close() {
      this.visible = false;
    },
    
    initCardTypeOptions() {
      const dic = JSON.parse(localStorage.dic);
      const data = dic['USER_CARD_TYPE'];
      if (data) {
        this.cardTypeOptions = Object.keys(data).map(code => ({
          value: code,
          label: data[code]
        }));
      }
    },
    
    getCardTypeName(code) {
      const option = this.cardTypeOptions.find(item => item.value === code);
      return option ? option.label : '';
    },
    
    openChangePassword() {
      this.$emit('changePassword');
      this.visible = false;
    },
  }
};
</script>

<style lang="scss">
.page-form {
  padding-bottom: 50px;
}
</style>